import { AtomicCondition, AtomicConditionType } from "../types/ses/sesItemConfigTypes";

// функция создания объекта условия в ses
const createObjectWithCondition = (type: AtomicConditionType, confirmationValue?: "yes" | "no"): AtomicCondition => {
	switch (type) {
		case "data":
			return {
				type,
				depth: "endpoint",
				id: "",
				operation: "exists",
				value: "",
			};
		case "variable":
			return {
				type,
				id: "",
				operation: "exists",
				value: "",
			};
		case "interval":
			return {
				type,
				equal: true,
				id: "",
			};
		case "confirmation":
			return {
				type,
				value: confirmationValue ? confirmationValue : "yes",
			};
		case "break":
			return {
				type,
			};
		case "event":
			return {
				type,
				id: "start",
			};
		default:
			const defaultType: never = type;
			return defaultType;
	}
};

export default createObjectWithCondition;
